import { render, staticRenderFns } from "./LoginIdForgot.vue?vue&type=template&id=d9ace2d2"
import script from "./LoginIdForgot.vue?vue&type=script&lang=ts"
export * from "./LoginIdForgot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports